import React from "react"

// This is a small loader that can be used for text of a button when loading.
export default function MiniLoader({ inverted = true }) {
  const useInverted = inverted ? "inverted" : ""
  return (
    <div style={{ width: "80px" }} className={`ui active inline loader tiny ${useInverted}`}></div>
  )
}
